let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6VyRb")).then(() => parcelRequire('12Ita'));